import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getSuppliersActionAsync } from '../redux/actions/SupplierOriginActions'

export const useSuppliersOrigin = () => {
  const { suppliersOriginState } = useSelector(
    (state: RootState) => state.supplierOrigin
  )

  const dispatch = useDispatch()

  const getSuppliersOrigin = () => {
    dispatch(getSuppliersActionAsync())
  }

  return { suppliersOriginState, getSuppliersOrigin }
}
